var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiscoveryGroup = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5418 0H12.2053C11.4601 0 10.856 0.59017 10.856 1.31818V27.6818C10.856 28.4098 11.4601 29 12.2053 29H17.5418C18.287 29 18.8911 28.4098 18.8911 27.6818V1.31818C18.8911 0.59017 18.287 0 17.5418 0Z",
    fill: "#4551B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68579 7.90625H1.3493C0.604103 7.90625 0 8.49642 0 9.22443V27.679C0 28.407 0.604103 28.9972 1.3493 28.9972H6.68579C7.43099 28.9972 8.0351 28.407 8.0351 27.679V9.22443C8.0351 8.49642 7.43099 7.90625 6.68579 7.90625Z",
    fill: "#4551B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3335 15.8125H22.997C22.2518 15.8125 21.6477 16.4027 21.6477 17.1307V27.6761C21.6477 28.4041 22.2518 28.9943 22.997 28.9943H28.3335C29.0787 28.9943 29.6828 28.4041 29.6828 27.6761V17.1307C29.6828 16.4027 29.0787 15.8125 28.3335 15.8125Z",
    fill: "#4551B5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiscoveryGroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/discoveryGroup.a5ffea68c1ccfa1548c2f785a5c18343.svg";